import { PanelBody, RangeControl } from '@wordpress/components';
import { PanelColorSettings } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

export default function CircleControls( { attributes, setAttributes } ) {
	return (
		<PanelBody
			title={ __( 'Circle', 'brandy-blocks' ) }
			initialOpen={ true }
		>
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Max value', 'brandy-blocks' ) }
				value={ attributes.maxValue }
				onChange={ ( v ) => setAttributes( { maxValue: v } ) }
				min={ 1 }
				max={ 99999 }
			/>
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Circle size (px)', 'brandy-blocks' ) }
				value={ attributes.circleSize }
				onChange={ ( v ) => setAttributes( { circleSize: v } ) }
				min={ 80 }
				max={ 400 }
				step={ 10 }
			/>
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Stroke width', 'brandy-blocks' ) }
				value={ attributes.strokeWidth }
				onChange={ ( v ) => setAttributes( { strokeWidth: v } ) }
				min={ 2 }
				max={ 20 }
			/>
			<PanelColorSettings
				title={ __( 'Circle colors', 'brandy-blocks' ) }
				initialOpen={ false }
				disableCustomColors={ false }
				colorSettings={ [
					{
						value: attributes.trackColor,
						onChange: ( v ) =>
							setAttributes( { trackColor: v } ),
						label: __( 'Track', 'brandy-blocks' ),
					},
					{
						value: attributes.progressColor,
						onChange: ( v ) =>
							setAttributes( { progressColor: v } ),
						label: __( 'Progress', 'brandy-blocks' ),
					},
				] }
			/>
		</PanelBody>
	);
}
